/**
 * Stable CSS class names for E2E — RPT history search + results.
 */
export const RPTH = {
    filtersRow: 'rpt-history-page__filters-row',
    fieldTopic: 'rpt-history-field--topic',
    inputSelectTopic: 'rpt-history-input--select-topic',
    filterActions: 'rpt-history-page__filter-actions',
    inputButtonSearch: 'rpt-history-input--button-search',
    resultsSection: 'rpt-history-page__results-section',
    resultBanner: 'rpt-history-page__result-banner',
    resultRowHint: 'rpt-history-page__result-row-hint',
    resultStatusHighlight: 'rpt-history-field--result-status-highlight',
    datagridWrap: 'rpt-history-page__datagrid-wrap',
    datagrid: 'rpt-history-page__datagrid',
} as const;

export const rpthCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
